import * as React from 'react';
import { forwardRef, useEffect } from 'react';

import { useField } from 'formik';

import { FieldFormGroupProps } from '../field_form_group';
import {
  ResizableTextAreaFormControl,
  type ResizableTextAreaFormControlProps,
  type ResizableTextAreaFormControlType,
} from '../resizable_text_area_form_control';
import { TextAreaFormControl, TextAreaFormControlProps, TextAreaFormControlType } from '../text_area_form_control';

type ResizableTextAreaFormGroupType = ResizableTextAreaFormControlType;
type ResizableTextAreaFormGroupProps = ResizableTextAreaFormControlProps & FieldFormGroupProps & { name: string };

export const FormikResizableTextAreaFormControl = forwardRef<
  ResizableTextAreaFormGroupType,
  ResizableTextAreaFormGroupProps
>(({ help, label, children, ...input }, ref) => {
  const [field] = useField(input.name);

  return <ResizableTextAreaFormControl ref={ref} {...field} {...input} />;
});
